import { ChangeEvent, FC } from 'react';
import { Checkbox } from '@doda/io-react/common';
import { CityDrillDownType } from '../types';
import styles from './index.module.scss';
import { DrillDownText } from '../../DrillDownText';

/**
 * Propsの型定義
 * @param drillDown 市区町村ドリルダウン
 * @param onChange 更新処理
 */
interface Props {
  drillDown: Omit<CityDrillDownType, 'type'>;
  onChange: (event: ChangeEvent<HTMLInputElement>, selectedId: string) => void;
}

export const CityDrillDown: FC<Props> = ({ drillDown, onChange }) => {
  const { title, jobCount, url, prefecture } = drillDown;

  return (
    <div>
      <DrillDownText title={title} jobCount={jobCount} url={url} size="L" />
      <div className={styles.cityDrillDown__prefecture}>
        <DrillDownText
          title={prefecture.title}
          jobCount={prefecture.jobCount}
          size="L"
          url={prefecture.url}
        />
      </div>
      <ul>
        {prefecture.cities.map((city) => (
          <li key={city.id} className={styles.cityDrillDown__checkbox}>
            <Checkbox
              value={city.id}
              checked={city.isChecked}
              label={
                <DrillDownText
                  title={city.title}
                  jobCount={city.jobCount}
                  url={city.url}
                  isBold={city.isChecked}
                  size="L"
                />
              }
              onChange={(event) => {
                if (city.isActiveOnChange) {
                  onChange(event, city.id);
                }
              }}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};
